import { render } from "./InquiryHypothesis.vue?vue&type=template&id=5a815de8&scoped=true"
import script from "./InquiryHypothesis.vue?vue&type=script&lang=js"
export * from "./InquiryHypothesis.vue?vue&type=script&lang=js"

import "./InquiryHypothesis.vue?vue&type=style&index=0&id=5a815de8&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a815de8"]])

export default __exports__